import { motion } from "framer-motion";
import { useI18n } from "@/lib/i18n";

const IBIZA_IMG =
  "https://images.unsplash.com/photo-1758448756167-88dc934c58e4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBzdW5zZXQlMjB0ZXJyYWNlfGVufDB8fHx8MTc3ODQyNjc2MHww&ixlib=rb-4.1.0&q=85";

export default function Ibiza() {
  const { t } = useI18n();
  return (
    <section
      id="ibiza"
      className="relative bg-sand-50 py-24 md:py-32 lg:py-40 overflow-hidden"
      data-testid="ibiza-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
          className="relative aspect-[16/9] md:aspect-[21/9] w-full overflow-hidden"
        >
          <img
            src={IBIZA_IMG}
            alt="Ibiza sunset terrace overlooking the Mediterranean"
            className="w-full h-full object-cover scale-[1.02] hover:scale-100 transition-transform duration-[2500ms] ease-out"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-ink-900/60 via-ink-900/30 to-transparent" />

          <div className="absolute inset-0 flex items-end md:items-center">
            <div className="p-8 md:p-14 lg:p-20 max-w-2xl text-sand-50">
              <span className="block text-[10px] md:text-xs tracking-[0.4em] uppercase text-gold mb-5 md:mb-7">
                — {t.ibiza.kicker}
              </span>
              <h2
                className="font-serif font-light leading-[1.05] tracking-tight text-3xl md:text-5xl lg:text-6xl mb-6 md:mb-8"
                data-testid="ibiza-title"
              >
                {t.ibiza.title}
              </h2>
              <p className="text-sm md:text-base text-sand-50/80 leading-relaxed max-w-lg">
                {t.ibiza.p}
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
